

import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";

import MasterTabs from "../AllTabs/MasterTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import Login from "../../Authentication/Login";
const initialFieldValues = {
  companyBankAccountId: "00000000-0000-0000-0000-000000000000",
  companyId: "",
  accountNo: "",
  accountName: "",
  bankName: "",
  ifsc: "",
  branch: "",
  status: true,
};
const CompanyBankAccounts = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [addShow, setAddShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
  const handleAddClose = () => {
    setAddShow(false);
    setRecordForEdit(null);
  };
  const handleAddShow = () => {
    setRecordForEdit(null); // Clear any previous edit
    setValues(initialFieldValues); // Reset form
    setAddShow(true);
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const GetData = async (pageNumber) => {
    const res = await apiService.get(
      `${config.GETBANKSBYCOMPANYID}/${user?.cid}`,
      pageSize,
      pageNumber
    );

    console.log(res);
    setLists(res.data);
    setPageNumber(res.pageNumber);
    setPageSize(res.pageSize);
    setTotalPages(res.totalPages);
    setData(res.data);
    setTotalRecords(res.totalRecords);
  };
  const GetLastPageData = () => {
    GetData(totalPages);
  };
  const GetFirstPageData = () => {
    GetData("1");
  };
  const GetPageData = (number) => {
    setPageNumber(number);
    if (pageNumber !== number) GetData(number);
  };
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }
  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const showEditDetails = (data) => {
    setRecordForEdit(data);
    setValues(data);
    setAddShow(true);
  };
  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETECOMPANYBANK, itemToDelete);
        await GetData(pageNumber);
      } catch (error) {
        // Error toast already handled by apiService
        // Optionally log or track error here
      }
      handleCloseDeleteModal();
    }
  };
  const validate = () => {
    let temp = {};
    temp.bankName = values.bankName === "" ? false : true;
    temp.accountName = values.accountName === "" ? false : true;
    temp.accountNo = values.accountNo === "" ? false : true;
    temp.ifsc = values.ifsc === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };
  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnLoading(true);
      var formData = {
        companyBankAccountId: values.companyBankAccountId,
        companyId: user?.cid,
        accountNo: values.accountNo,
        accountName: values.accountName,
        bankName: values.bankName,
        ifsc: values.ifsc,
        branch: values.branch,
        status: values.status,
      };
      try {
        const isNew =
          formData.companyBankAccountId === "00000000-0000-0000-0000-000000000000";
        if (isNew) {
            console.log("Creating new bank account:", formData);
          await apiService.create(config.CREATECOMPANYBANK, formData);
        } else {
            console.log("Updating bank account:", formData);
          await apiService.update(config.UPDATECOMPANYBANK, formData);
        }
        await GetData(pageNumber);
        resetForm();
      } finally {
        setBtnLoading(false); // ensure loading button resets even on error
      }
    }
  };
 const handleInputChange = (e) => {
    const { name, value } = e.target;
    const fieldsToUppercase = ["bankName", "accountName", "ifsc", "branch"]; // Added more fields to uppercase for consistency

    let finalValue = value;

    // Specifically handle the 'status' field to convert it to a boolean
    if (name === "status") {
        finalValue = value === "true"; // This expression results in true or false
    } else if (fieldsToUppercase.includes(name)) {
        finalValue = value.toUpperCase();
    }
    
    setValues({
        ...values,
        [name]: finalValue,
    });
};
  const resetForm = () => {
    setValues(initialFieldValues);
    setAddShow(false);
    setBtnLoading(false);
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading]);
  if (loading) return <p>Loading...</p>;

  if (!user) {
    navigate("/");
  }
  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MasterTabs pageName="COMPANYBANK" />
                </div>
                <div className="me-2 pb-1">
                  <div className="row g-4 align-items-center">
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-primary add-btn"
                          onClick={handleAddShow}
                        >
                          <i className="ri-add-line align-bottom me-1" /> Add
                           Bank Account
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="customerTable">
                      <thead className="bg-soft-success bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Account Name</th>
                          <th>Account Number</th>
                          <th>Bank Name</th>
                          <th>IFSC</th>
                          <th>Branch</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody className="list form-check-all">
                        {lists.length > 0 &&
                          lists.map((v, index) => (
                            <tr key={v.companyBankAccountId}>
                              <td>{index + 1}</td>
                              <td>{v.accountName}</td>
                              <td>{v.accountNo}</td>
                              <td>{v.bankName}</td>
                              <td>{v.ifsc}</td>
                              <td>{v.branch}</td>
                               <td>
          <span className={`badge ${v.status ? "bg-success" : "bg-danger"}`}>
            {v.status ? "Active" : "Inactive"}
          </span>
        </td>
                              <td>
                                {/* Hide action buttons for MAIN branch type */}
                             
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={(e) => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Delete"
                                    >
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) =>
                                          handleOpenDeleteModal(v.companyBankAccountId)
                                        }
                                      >
                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                    <div className="flex-shrink-0">
                      <div className="text-muted">
                        Showing{" "}
                        <span className="fw-semibold">{lists.length}</span> of{" "}
                        <span className="fw-semibold">{totalRecords}</span>{" "}
                        Results
                      </div>
                    </div>
                    <ul className="pagination pagination-separated pagination-sm mb-0">
                      <li
                        className={
                          "page-item" + data.previousPage === null
                            ? "disabled"
                            : ""
                        }
                        onClick={() => GetFirstPageData()}
                      >
                        <Link className="page-link">Previous</Link>
                      </li>
                      {renderPageNumbers}
                      <li
                        className={
                          "page-item" + data.nextPage === null ? "disabled" : ""
                        }
                        onClick={() => GetLastPageData()}
                      >
                        <Link className="page-link">Next</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={addShow} onHide={handleAddClose}>
          <Modal.Header>
            <Modal.Title>
              {values.companyBankAccountId === "00000000-0000-0000-0000-000000000000"
                ? "Add"
                : "Edit"}{" "}
              Bank Account
            </Modal.Title>
          </Modal.Header>
                  <Modal.Body>
             <form onSubmit={handleSubmit} autoComplete="off" noValidate>
              <div className="mb-3">
                <label className="form-label">Bank Name</label>
                <input type="text" value={values.bankName || ""} name="bankName" onChange={handleInputChange} className={`form-control ${applyErrorClass("bankName")}`} placeholder="e.g., STATE BANK OF INDIA" />
                {errors.bankName && <div className="invalid-feedback">{errors.bankName}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Account Holder Name</label>
                <input type="text" value={values.accountName || ""} name="accountName" onChange={handleInputChange} className={`form-control ${applyErrorClass("accountName")}`} placeholder="e.g., JOHN DOE" />
                {errors.accountName && <div className="invalid-feedback">{errors.accountName}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Account Number</label>
                <input type="text" value={values.accountNo || ""} name="accountNo" onChange={handleInputChange} className={`form-control ${applyErrorClass("accountNo")}`} placeholder="Enter account number" />
                {errors.accountNo && <div className="invalid-feedback">{errors.accountNo}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">IFSC Code</label>
                <input type="text" value={values.ifsc || ""} name="ifsc" onChange={handleInputChange} className={`form-control ${applyErrorClass("ifsc")}`} placeholder="Enter IFSC code" />
                {errors.ifsc && <div className="invalid-feedback">{errors.ifsc}</div>}
              </div>
              <div className="mb-3">
                <label className="form-label">Branch</label>
                <input type="text" value={values.branch || ""} name="branch" onChange={handleInputChange} className="form-control" placeholder="Enter branch name (Optional)" />
              </div>
              <div className="mb-3">
                  <label htmlFor="status" className="form-label">
                    Status
                  </label>
                  <select
                    name="status"
                    value={values.status}
                    onChange={handleInputChange}
                    className={"form-select" + applyErrorClass("status")}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
            
           
                     <Modal.Footer>
                  <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                    {btnLoading === false ? (
                      <button type="submit" className="btn btn-primary">
                        {values.companyBankAccountId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Submit"
                          : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled
                      >
                        Please wait...
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  </div>
                </Modal.Footer>
                
            </form>
        </Modal.Body>
        </Modal>
       
        <DeleteAlert
          show={showDeleteModal}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
      </div>
    
  );
};

export default CompanyBankAccounts;
